import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import { Row, Col } from 'antd';
import AppHeader from './utils/app/appHeader';
import { useProfileDetails } from 'hooks/profile/profile';


function AppLayout() {
    const { pathname } = useLocation();
    const { data: profileData, refetch } = useProfileDetails();

    // Permissions live on the profile, so refetch it on every navigation: a role
    // changed by an administrator takes effect on the user's next page change
    // rather than at their next login. An in-flight fetch is reused, not repeated.
    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <div className="service-view error-page">
            <Row>
                <Col md={24} xs={24}>
                    <AppHeader profileData={profileData} />
                </Col>
                <Col md={24} xs={24}>
                    <Outlet />
                </Col>
            </Row>
            {/* Outside the Row: the layout CSS stretches the Row's last Col to fill the page. */}
            <footer className="app-footer">
                <span>&copy; {new Date().getFullYear()} Woh Hup Engineering. All rights reserved.</span>
            </footer>
        </div>
    );
}

export default AppLayout;
